/**
 * Internal dependencies
 */
import { getExtraSegmentationInfo } from '../index';
import type { Attributes } from '../../../../../../packages/segmentation-rule-library/rules/device-type/types';

export const type = 'nab/device-type';

export function validate( attributes: Attributes ): boolean {
	const { condition, values } = attributes;

	const visitorDeviceType = getExtraSegmentationInfo().device;
	if ( 'string' !== typeof visitorDeviceType ) {
		return false;
	}

	switch ( condition ) {
		case 'is-equal-to':
			return values.some( ( { value } ) => value === visitorDeviceType );

		case 'is-not-equal-to':
			return values.every( ( { value } ) => value !== visitorDeviceType );
	}
}
